import React from 'react'
import axios from 'axios'
import { CONSTANTS } from 'src/constants'

export const MuddaAPI = {
  // ...

  // mapping the API of interest
  get: function (token) {
    return axios.request({
      method: 'GET',
      url: `${process.env.REACT_APP_BASEURL}/mudda/get`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: CONSTANTS.NETWORK_TIME_OUT,
      timeoutErrorMessage: CONSTANTS.NETWORK_TIME_OUT_MESSAGE,
    })
  },

  getSingle: function (token, selectedItem) {
    console.log(selectedItem)
    return axios.request({
      method: 'GET',
      url: `${process.env.REACT_APP_BASEURL}/mudda/get/${selectedItem}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: CONSTANTS.NETWORK_TIME_OUT,
      timeoutErrorMessage: CONSTANTS.NETWORK_TIME_OUT_MESSAGE,
    })
  },

  createMudda: function (token, data) {
    return axios.request({
      method: 'POST',
      url: `${process.env.REACT_APP_BASEURL}/mudda/store`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
      timeout: CONSTANTS.NETWORK_TIME_OUT,
      timeoutErrorMessage: CONSTANTS.NETWORK_TIME_OUT_MESSAGE,
    })
  },

  editMudda: function (token, data, selectedItem) {
    return axios.request({
      method: 'POST',
      url: `${process.env.REACT_APP_BASEURL}/mudda/update/${selectedItem}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: CONSTANTS.NETWORK_TIME_OUT,
      timeoutErrorMessage: CONSTANTS.NETWORK_TIME_OUT_MESSAGE,
    })
  },

  delete: function (token, selectedItem) {
    return axios.request({
      method: 'GET',
      url: `${process.env.REACT_APP_BASEURL}/mudda/delete/${selectedItem}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: CONSTANTS.NETWORK_TIME_OUT,
      timeoutErrorMessage: CONSTANTS.NETWORK_TIME_OUT_MESSAGE,
    })
  },

  // ...
}
